<template>
	<div class="group-request-item">
		<div class="request-avatar" @click="onShowDetail">
			<head-image :size="56" :id="applicant.id" :name="applicant.nickName" :url="applicant.headImage"></head-image>
		</div>
		<div class="request-info" @click="onShowDetail">
			<div class="title-row">
				<div class="nick-name">{{ applicant.nickName || '未知用户' }}</div>
				<div class="group-name">{{ groupName }}</div>
			</div>
			<div class="info-text">
				<div v-if="request.remark">{{ request.remark }}</div>
				<div v-else-if="isSender">您申请加入该群聊</div>
				<div v-else>请求加入该群聊</div>
				<span class="group-qq" v-if="request.groupQq">（群号：{{ request.groupQq }}）</span>
			</div>
			<div class="status-text" v-if="!isPending">
				<span v-if="request.status === $enums.REQUEST_STATUS.APPROVED">已同意</span>
				<span v-else-if="request.status === $enums.REQUEST_STATUS.REJECTE">已拒绝</span>
				<span v-else-if="request.status === $enums.REQUEST_STATUS.EXPIRED">已撤回</span>
				<span v-if="request.handlerNickName">（由 {{ request.handlerNickName }} 审核）</span>
			</div>
		</div>
		<div class="btn-group" v-if="isPending">
			<el-button v-if="isSender" type="danger" size="mini" @click.stop="onRecall">撤回</el-button>
			<div v-else class="approve-btns">
				<el-button type="danger" size="mini" @click.stop="onReject">拒绝</el-button>
				<el-button type="primary" size="mini" @click.stop="onApprove">同意</el-button>
			</div>
		</div>

		<el-dialog title="群聊申请详情" :visible.sync="detailVisible" width="400px" append-to-body>
			<div class="detail">
				<div class="section">
					<div class="section-title">申请人</div>
					<div class="section-content">
						<span class="main-text">{{ request.sendNickName }}</span>
						<span class="sub-text">
							{{ isSender ? '我' : request.sendNickName }}：{{ request.remark || '申请加入群聊' }}
						</span>
					</div>
				</div>
				<div class="section">
					<div class="section-title">群聊</div>
					<div class="section-content">
						<span class="main-text">{{ groupName }}</span>
						<span class="sub-text">群号：{{ request.groupQq }}</span>
					</div>
				</div>
				<div class="section">
					<div class="section-title">申请时间</div>
					<div class="section-content">
						<span class="time-text">{{ $date.formatDateTime(request.applyTime) }}</span>
					</div>
				</div>
				<div class="section" v-if="!isPending">
					<div class="section-title">处理结果</div>
					<div class="section-content">
						<span class="status-text">
							<span v-if="request.status === $enums.REQUEST_STATUS.APPROVED">已同意</span>
							<span v-else-if="request.status === $enums.REQUEST_STATUS.REJECTE">已拒绝</span>
							<span v-else-if="request.status === $enums.REQUEST_STATUS.EXPIRED">已撤回</span>
							<span v-if="request.handlerNickName">（由 {{ request.handlerNickName }} 审核）</span>
						</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailVisible = false">关 闭</el-button>
				<el-button v-if="isPending && !isSender" type="primary" @click="onApprove">同 意</el-button>
				<el-button v-if="isPending && !isSender" type="danger" @click="onReject">拒 绝</el-button>
				<el-button v-if="isPending && isSender" type="danger" @click="onRecall">撤 回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "groupRequestItem",
	components: { HeadImage },
	props: {
		request: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			detailVisible: false
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		isSender() {
			return this.request.sendId === this.mine.id;
		},
		isPending() {
			return this.request.status === this.$enums.REQUEST_STATUS.PENDING;
		},
		groupName() {
			const group = this.groupStore.findGroup(this.request.groupId);
			return group ? (group.showGroupName || group.name) : `群ID: ${this.request.groupId}`;
		},
		applicant() {
			return {
				id: this.request.sendId,
				nickName: this.request.sendNickName,
				headImage: this.request.sendHeadImage
			};
		}
	},
	methods: {
		onShowDetail() {
			this.detailVisible = true;
		},
		onApprove() {
			this.$http({
				url: "/group/request/approve?id=" + this.request.id,
				method: "POST"
			}).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.$message.success("已同意该群聊申请");
				this.detailVisible = false;
			});
		},
		onReject() {
			this.$http({
				url: "/group/request/reject?id=" + this.request.id,
				method: "POST"
			}).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.$message.success("已拒绝该群聊申请");
				this.detailVisible = false;
			});
		},
		onRecall() {
			this.$http({
				url: "/group/request/recall?id=" + this.request.id,
				method: "POST"
			}).then(() => {
				this.groupRequestStore.removeRequest(this.request.id);
				this.$message.success("您已撤回群聊申请");
				this.detailVisible = false;
			});
		}
	}
}
</script>

<style scoped lang="scss">
.group-request-item {
	display: flex;
	position: relative;
	align-items: center;
	cursor: pointer;
	margin: 0 30px;
	padding: 10px;
	border-bottom: 1px solid #ccc;

	&:hover {
		background-color: var(--im-background-active);
	}

	.request-avatar {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.request-info {
		margin: 0 15px;
		flex: 3;
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		overflow: hidden;

		.title-row {
			display: flex;
			align-items: center;
			gap: 10px;
			line-height: 30px;
			min-width: 0;

			.nick-name {
				font-weight: 600;
				font-size: 16px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 55%;
			}

			.group-name {
				color: var(--im-text-color-light);
				font-size: 13px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				flex: 1;
				text-align: left;
				min-width: 0;
			}
		}

		.info-text {
			display: flex;
			align-items: center;
			word-break: break-all;
			font-size: 14px;
			line-height: 20px;
			text-align: left;
			color: var(--im-text-color-light);
			overflow: hidden;

			.group-qq {
				margin-left: 6px;
				white-space: nowrap;
				color: var(--im-text-color-lighter);
			}
		}

		.status-text {
			margin-top: 2px;
			text-align: left;
			color: var(--im-text-color-lighter);
			font-size: 12px;
		}
	}

	.btn-group {
		display: flex;
		flex-direction: column;
		row-gap: 6px;
	}
}

.detail {
	.section {
		margin-bottom: 12px;

		.section-title {
			font-size: var(--im-font-size-small);
			color: var(--im-text-color-light);
			margin-bottom: 4px;
		}

		.section-content {
			display: flex;
			flex-direction: column;
			row-gap: 2px;

			.main-text {
				font-size: var(--im-font-size);
				color: var(--im-text-color);
			}

			.sub-text {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-lighter);
			}

			.time-text {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-lighter);
			}

			.status-text {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-lighter);
			}
		}
	}
}
</style>

